import page from './Page'
import pageContent from './PageContent'
import spacer from './Spacer'

export const Page = page
export const PageContent = pageContent
export const Spacer = spacer
